import React, { createContext, useContext, useState, ReactNode } from 'react';

import { initialSearchFilters, PackageUtilizationSearchFilters } from './SearchFilters';

interface SearchFiltersContextType {
  searchFilters: PackageUtilizationSearchFilters;
  setSearchFilters: React.Dispatch<React.SetStateAction<PackageUtilizationSearchFilters>>;
  resetFilters: () => void;
}

const SearchFiltersContext = createContext<SearchFiltersContextType | undefined>(undefined);

interface SearchFiltersProviderProps {
  children: ReactNode;
}

export const SearchFiltersProvider = ({ children }: SearchFiltersProviderProps): JSX.Element => {
  const [searchFilters, setSearchFilters] = useState<PackageUtilizationSearchFilters>(initialSearchFilters);

  const resetFilters = (): void => {
    setSearchFilters(initialSearchFilters);
  };

  const value = {
    searchFilters,
    setSearchFilters,
    resetFilters,
  };

  return <SearchFiltersContext.Provider value={value}>{children}</SearchFiltersContext.Provider>;
};

export const useSearchFilters = (): SearchFiltersContextType => {
  const context = useContext(SearchFiltersContext);
  if (context === undefined) {
    throw new Error('useSearchFilters must be used within a SearchFiltersProvider');
  }

  return context;
};
